// extracted by mini-css-extract-plugin
module.exports = {"section":"_32Mwx"};